/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateProjectTaskBudgetCostCommand } from '../../models/update-project-task-budget-cost-command';
import { UpdateProjectTaskBudgetCostCommandResult } from '../../models/update-project-task-budget-cost-command-result';

export interface ApiTaskBudgetCostUpdateTaskBudgetCostPost$Params {
      body?: UpdateProjectTaskBudgetCostCommand
}

export function apiTaskBudgetCostUpdateTaskBudgetCostPost(http: HttpClient, rootUrl: string, params?: ApiTaskBudgetCostUpdateTaskBudgetCostPost$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectTaskBudgetCostCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiTaskBudgetCostUpdateTaskBudgetCostPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateProjectTaskBudgetCostCommandResult>;
    })
  );
}

apiTaskBudgetCostUpdateTaskBudgetCostPost.PATH = '/api/TaskBudgetCost/UpdateTaskBudgetCost';
